import {
  ChangeEventHandler,
  DetailedHTMLProps,
  forwardRef,
  ForwardRefRenderFunction,
  InputHTMLAttributes
} from 'react'
import { InputStyled, LabelStyled } from './styles'
import { LabelWrapper } from '../Select/style'

type InputProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>

interface RadioProps extends InputProps {
  value: string
  name: string
  label: string
  onChange?: ChangeEventHandler<HTMLInputElement>
  labelAdornment?: React.ReactNode
  disabled?: boolean
}

const RadioComponent: ForwardRefRenderFunction<HTMLInputElement, RadioProps> = (
  { value, name, label, labelAdornment, disabled, onChange, ...rest },
  ref
) => {
  return (
    <LabelWrapper>
      <LabelStyled disabled={disabled}>
        <InputStyled
          ref={ref}
          data-testid="radio-component"
          type="radio"
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          {...rest}
        />
        {label}
      </LabelStyled>
      {labelAdornment && <>{labelAdornment}</>}
    </LabelWrapper>
  )
}

export const Radio = forwardRef(RadioComponent)
